import { DR_SETUP_GROUPS } from "../constants/_constant";
import SetupCard from "./SetupCard";
import "../css/DrSetup.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import { checkPermission } from "../../roles_and_permissions/_features";
import {
  clinicAtom,
  permissionAtom,
} from "../../_helper/constant/constant-atom";
import { useAtom } from "jotai";
import SetupTable from "./SetupTable";
import ReactQuill from "react-quill";
import Richtexteditor from "../../components/admin/myfolder/editor/Richtexteditor";
import { useState } from "react";
import { useSecureUpdateItem } from "../../_helper/actions/mutation/items";
import CuSpinner from "../../common_component/component/CuSpinner";
import { toast } from "react-toastify";
import { useItemsFilterNew } from "../../_helper/actions/app/items";

const DrSetup = () => {
  const navigate = useNavigate();
  const [permission] = useAtom(permissionAtom);
  const [searchParams] = useSearchParams();
  const [noticeValue, setNoticeValue] = useState("");
  const groupId = searchParams.get("group_id");
  const [clinic] = useAtom(clinicAtom);
  // const [openViewMessage, setOpenViewMessage] = useState(false);

  const handleGroupClick = (idx) => {
    if (idx === 18) {
      navigate("/new/procedure-setup");
    } else if (idx === 19) {
      navigate("/new/setup/item");
    } else if (idx === 20) {
      navigate("/new/setup/vendor");
    } else if (idx === 21) {
      navigate("/new/setup/warehouse");
    } else if (idx === 22) {
      navigate("/new/setup/workflow");
    } else if (idx === 24) {
      navigate("/new/setup/preconsultation");
    } else if (idx === 25) {
      navigate("/new/setup/uom");
    } else if (idx === 27) {
      navigate("/new/setup/linked-doctors");
    } else if (idx === 26) {
      navigate("/new/setup/medicine-schedules");
    } else if (idx === 28) {
      navigate("/new/setup/ward-management");
    } else {
      navigate(`/new/setup?group_id=${idx}&option_id=0`);
    }
  };

  const { data: noticeData } = useItemsFilterNew(
    "users/get_patch_website/",
    `?clinic_id=${clinic?.id}`,
    clinic?.id ? true : false,
    (response) => setNoticeValue(response?.data?.data?.heading)
  );

  const updateNoticeMutation = useSecureUpdateItem("users/get_patch_website/");

  const extractPlainText = (html) => {
    // Function to extract plain text from HTML if needed
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.innerText;
  };

  const handleSaveNotice = () => {
    const plainText = extractPlainText(noticeValue);
    updateNoticeMutation.mutate(
      {
        id: null,
        data: {
          clinic_id: clinic?.id,
          payload: {
            heading: plainText,
          },
        },
      },
      {
        onSuccess: (res) => {
          toast.success("Notice updated successfully");
        },
        onError: (err) => {
          toast.error(err.response.data.message);
        },
      }
    );
  };

  const handleChange = (value) => {
    setNoticeValue(value);
  };

  return groupId ? (
    <SetupTable />
  ) : (
    <>
      <div className="cu-dr-setup">
        {DR_SETUP_GROUPS.map((sgroup, i) => {
          if (
            checkPermission(permission?.allowed_features, sgroup?.featureId)
          ) {
            return (
              <SetupCard
                key={sgroup?.id}
                group={sgroup}
                index={i}
                description={sgroup?.description}
                onClick={handleGroupClick}
              />
            );
          }
        })}
      </div>

      <div className="p-4 gap-3">
        <ReactQuill
          theme="snow"
          value={noticeValue}
          onChange={handleChange}
          placeholder="Type here, your Instructions on notice board"
          className="sub-texteditor text-left"
          id="editor"
        />
        <div className="flex justify-end mt-2">
          <button
            className={`border border-[#00000033] py-2 px-4 rounded-md bg-[#C7EAC9]`}
            onClick={handleSaveNotice}
          >
            {updateNoticeMutation.isLoading ? <CuSpinner /> : "Save"}
          </button>
        </div>
      </div>
    </>
  );
};

export default DrSetup;
